import React from 'react';
import { Box, Container, Header, SpaceBetween, Spinner, StatusIndicator } from '@amzn/awsui-components-react-v3';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { UrlHelper } from '../../utils/url-helper';
import { QUERY_KEYS, CACHE_TIMES } from './constants';
import { WebsiteViewService } from 'src/model/WebsiteViewService';

export const WebsiteSummary = React.memo((): JSX.Element | null => {
    useLocation();
    const website = UrlHelper.getParamValue('website');

    const { data: summaryData, isFetching: summaryLoading, error: summaryError } = useQuery({
        queryKey: [QUERY_KEYS.WEBSITE_SUMMARY, website],
        queryFn: () => new WebsiteViewService().getWebsiteSummary(website || ''),
        enabled: !!website,
        staleTime: CACHE_TIMES.STALE_TIME,
        cacheTime: CACHE_TIMES.CACHE_TIME,
        retry: false,
    });

    return (
      <Box margin={{ bottom: "l" }}>
        <Container header={<Header variant="h2"> Website Summary</Header>}>
            {summaryLoading ? (
              <SpaceBetween direction="horizontal" size="xs">
                <Spinner />
                <span>Generating summary...</span>
              </SpaceBetween>
            ) : summaryError ? (
              <StatusIndicator type="error">Failed to generate summary.</StatusIndicator>
            ) : (
              <div style={{ whiteSpace: "pre-line" }}>
                <Box variant="p" fontSize="body-m">
                  {summaryData?.summary || "Summary not available."}
                </Box>
              </div>
            )}
        </Container>
      </Box>
    );
});

WebsiteSummary.displayName = 'WebsiteSummary';
